var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Auto Enabled")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoenable),
      expression: "autoenable"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "autoenable"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.autoenable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Enabled")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Disabled")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listHubZone,
      "track-by": "zoneId",
      "label": "zoneName",
      "multiple": false,
      "placeholder": "Select Zone",
      "hide-selected": true,
      "name": "zone"
    },
    on: {
      "select": _vm.selectedZone
    },
    model: {
      value: (_vm.zone),
      callback: function($$v) {
        _vm.zone = $$v
      },
      expression: "zone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.liststateData,
      "track-by": "stateId",
      "label": "stateName",
      "multiple": false,
      "placeholder": "Select State",
      "hide-selected": true,
      "name": "state"
    },
    on: {
      "select": _vm.selectedState
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cityList,
      "track-by": "cityId",
      "label": "cityName",
      "multiple": false,
      "placeholder": "Select City",
      "hide-selected": true,
      "name": "city"
    },
    on: {
      "select": _vm.selectedCity
    },
    model: {
      value: (_vm.city),
      callback: function($$v) {
        _vm.city = $$v
      },
      expression: "city"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.hubtypelist,
      "track-by": "value",
      "label": "text",
      "multiple": false,
      "placeholder": "Select Hub Type",
      "hide-selected": true,
      "name": "hubtype"
    },
    model: {
      value: (_vm.hubtype),
      callback: function($$v) {
        _vm.hubtype = $$v
      },
      expression: "hubtype"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.hublist,
      "track-by": "facilityId",
      "label": "facilityName",
      "multiple": false,
      "placeholder": "Select Hub Name",
      "name": "hub"
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Apply")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('fieldset', [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHub('hubsave')
      }
    }
  }, [_c('div', {
    class: ("" + ((_vm.bagOutHubAndBagDetails.length>0) ? 'showdest' : '')),
    staticStyle: {
      "overflow-x": "auto",
      "margin-top": "1%"
    },
    attrs: {
      "disabled": _vm.bagOutHubAndBagDetails.length <= 0
    }
  }, [_c('table', {
    staticClass: "table-hover datatables tbl",
    staticStyle: {
      "width": "100%",
      "overflow-y": "auto"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllHub),
      expression: "checkAllHub"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllHub) ? _vm._i(_vm.checkAllHub, null) > -1 : (_vm.checkAllHub)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllFacility($event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllHub,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllHub = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllHub = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllHub = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "all"
    }
  }, [_vm._v("  All")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllSurface),
      expression: "checkAllSurface"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox",
      "id": "allsurface"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllSurface) ? _vm._i(_vm.checkAllSurface, null) > -1 : (_vm.checkAllSurface)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType('SurfaceBag', $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllSurface,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllSurface = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllSurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllSurface = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allsurface"
    }
  }, [_vm._v("  Surface")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllRTO),
      expression: "checkAllRTO"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllRTO) ? _vm._i(_vm.checkAllRTO, null) > -1 : (_vm.checkAllRTO)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("RTOBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllRTO,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllRTO = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllRTO = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllRTO = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allRTO"
    }
  }, [_vm._v("  RTO")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllDTO),
      expression: "checkAllDTO"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllDTO) ? _vm._i(_vm.checkAllDTO, null) > -1 : (_vm.checkAllDTO)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("DTOBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllDTO,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllDTO = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllDTO = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllDTO = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allDTO"
    }
  }, [_vm._v("  DTO")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllAIR),
      expression: "checkAllAIR"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllAIR) ? _vm._i(_vm.checkAllAIR, null) > -1 : (_vm.checkAllAIR)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("AirBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllAIR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllAIR = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllAIR = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllAIR = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allAIR"
    }
  }, [_vm._v("  AIR")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllNDD),
      expression: "checkAllNDD"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllNDD) ? _vm._i(_vm.checkAllNDD, null) > -1 : (_vm.checkAllNDD)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("NDDBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllNDD,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllNDD = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllNDD = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllNDD = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allNDD"
    }
  }, [_vm._v("  NDD")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllDOC),
      expression: "checkAllDOC"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllDOC) ? _vm._i(_vm.checkAllDOC, null) > -1 : (_vm.checkAllDOC)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("DOCBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllDOC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllDOC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllDOC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllDOC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allDOC"
    }
  }, [_vm._v("  DOC")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllRSC),
      expression: "checkAllRSC"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllRSC) ? _vm._i(_vm.checkAllRSC, null) > -1 : (_vm.checkAllRSC)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("RSCBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllRSC,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllRSC = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllRSC = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllRSC = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allRSC"
    }
  }, [_vm._v("  RSC")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllMaster),
      expression: "checkAllMaster"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllMaster) ? _vm._i(_vm.checkAllMaster, null) > -1 : (_vm.checkAllMaster)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("MasterBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllMaster,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllMaster = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllMaster = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllMaster = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allMaster"
    }
  }, [_vm._v("  Master")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllSurfaceCargo),
      expression: "checkAllSurfaceCargo"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllSurfaceCargo) ? _vm._i(_vm.checkAllSurfaceCargo, null) > -1 : (_vm.checkAllSurfaceCargo)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("SurfaceCargoBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllSurfaceCargo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllSurfaceCargo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllSurfaceCargo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllSurfaceCargo = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allSurfaceCargo"
    }
  }, [_vm._v("  Surface Cargo")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllAirCargo),
      expression: "checkAllAirCargo"
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllAirCargo) ? _vm._i(_vm.checkAllAirCargo, null) > -1 : (_vm.checkAllAirCargo)
    },
    on: {
      "click": function($event) {
        return _vm.checkAllBagType("AirCargoBag", $event)
      },
      "change": function($event) {
        var $$a = _vm.checkAllAirCargo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllAirCargo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllAirCargo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllAirCargo = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "allAirCargo"
    }
  }, [_vm._v("  Air Cargo")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagOutHubAndBagDetails), function(hub, index) {
    return _c('tr', [_c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableHub
      },
      domProps: {
        "checked": _vm.checkedHub[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.updateCheckDest(hub.hubId, $event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "for": hub.hubId
      }
    }, [_vm._v(_vm._s(hub.hubName) + " (" + _vm._s(hub.hubId) + ")")])]), _vm._v(" "), _c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['SurfaceBag']
      },
      domProps: {
        "checked": _vm.checkedSurfaceBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "SurfaceBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['RTOBag']
      },
      domProps: {
        "checked": _vm.checkedRTOBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "RTOBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['DTOBag']
      },
      domProps: {
        "checked": _vm.checkedDTOBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "DTOBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['AirBag']
      },
      domProps: {
        "checked": _vm.checkedAirBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "AirBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['NDDBag']
      },
      domProps: {
        "checked": _vm.checkedNDDBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "NDDBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['DOCBag']
      },
      domProps: {
        "checked": _vm.checkedDOCBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "DOCBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['RSCBag']
      },
      domProps: {
        "checked": _vm.checkedRSCBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "RSCBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['MasterBag']
      },
      domProps: {
        "checked": _vm.checkedMasterBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "MasterBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['SurfaceCargoBag']
      },
      domProps: {
        "checked": _vm.checkedSurfaceCargoBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "SurfaceCargoBag", $event)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disableBag['AirCargoBag']
      },
      domProps: {
        "checked": _vm.checkedAirCargoBag[hub.hubId]
      },
      on: {
        "change": function($event) {
          return _vm.checkBagType(hub.hubId, "AirCargoBag", $event)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.bagOutHubAndBagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "padding": "0.25rem"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bagOutHubAndBagDetails.length > 0),
      expression: "bagOutHubAndBagDetails.length>0"
    }],
    staticClass: "common-success",
    staticStyle: {
      "margin-left": "80%"
    },
    attrs: {
      "type": "submit",
      "disabled": Object.keys(this.inputPayload).length <= 0
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bagOutHubAndBagDetails.length > 0),
      expression: "bagOutHubAndBagDetails.length>0"
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": Object.keys(this.inputPayload).length <= 0,
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.cancelonclick
    }
  }, [_vm._v("Cancel")])])])])], 1)])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to add / update auto bagout configuration?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false;
        _vm.addBagOutConfiguration();
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4cdd3c","hasScoped":true}!./src/views/components/AutoBagOutConfiguration_v1/AutoBagOutConfiguration/AutoBagOutConfiguration.html
// module id = 1978
// module chunks = 2